import { render, staticRenderFns } from "./ClientPriceInput.vue?vue&type=template&id=28bf33f6&scoped=true"
import script from "./ClientPriceInput.vue?vue&type=script&lang=js"
export * from "./ClientPriceInput.vue?vue&type=script&lang=js"
import style0 from "./ClientPriceInput.vue?vue&type=style&index=0&id=28bf33f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf33f6",
  null
  
)

export default component.exports